/* The desktop app, as far as the rest of the code needs to know about it.
 *
 * On the web the page is served by the same site that answers /api and
 * /.netlify/identity, so every path is relative. In the Tauri build the page
 * comes out of the app bundle and the server is somewhere else; VITE_API_BASE,
 * set at build time, says where. Unset, it is '' and nothing changes.
 *
 * No Tauri package is imported. The shell exposes `window.__TAURI__`
 * (withGlobalTauri), and on the web that is simply absent.
 */

export const API_BASE = (import.meta.env?.VITE_API_BASE || '').replace(/\/+$/, '');

/** A server path, absolute when the app is not served by the server. */
export const api = (path) => API_BASE + path;

export const isDesktop = () => !!globalThis.__TAURI__;

/**
 * Save before the app goes. A browser tab fires `pagehide` on close; a web view
 * being torn down by Cmd+Q may not, and the last 400ms of typing would go with
 * it. So the shell asks first, waits for `saved`, and only then quits — or
 * gives up waiting after a few seconds, so a hung page can't hold the app open.
 */
export function saveBeforeQuit(save) {
  const tauri = globalThis.__TAURI__;
  if (!tauri?.event?.listen) return;
  tauri.event.listen('longhand:save-before-quit', async () => {
    try { await save(); } catch (e) {}
    tauri.core.invoke('saved');
  });
}
